import React from 'react'
import { Query, Mutation } from 'react-apollo'
import {
    CountUsers, CountUsersStates,
    CountProposes, AnunciosAll, CreateSkills, newHabs, CreateCategory
} from '../../queries/dashboard'
import Navbar from '../../components/newNavbar/navbar'
import Modal from '../../components/Modal/modal'
import Chart from "react-google-charts"
import './dashboard.scss'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from '../../queries/endpoint'
import * as dayjs from 'dayjs'
import Simplert from 'react-simplert'
import Button from '../../components/newButton/button'
import Input from '../../components/newInput/input'
import Loading from '../../components/loading/loading'
import { Categories } from '../../queries/category'
import ErrorBoundary from '../../components/errorBoundary/errorBoundary'
import IconCtg from '../../components/iconCtg/iconCtg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FileInput } from '../../components/fileInput/fileInput'
import axios from 'axios'

export default class anuncios extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            proposett: 0,
            proposeaberto: 0,
            proposeaceito: 0,
            proposecalcelado: 0,
            proposefinalizado: 0,
            proposeNO: 0,
            proposerecusado: 0,
            dayData: [["Dia", "Total de usuários", "Cadastros de profissionais"]],
            loading: false,
            show: false,
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot',
            open: false,
            showCat: false,
            dataEstados: []
        }

        this.form = {}
        this.editCat = false

        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        if (cache && cache.user) {
            console.log(cache.user.role)
            if (cache.user.role === "USER") {
                window.location.href = "/perfil"
            } else if (cache.user.role === "ADMINA" && !this.editCat) {
                this.editCat = true
            }
        } else {
            window.location.href = "/login"
        }

        const client = new GraphQLClient(endpoint, {
            headers: {
                Authorization: `Bearer ${cache.token}`,
            },
        })

       /* client.request(CountUsers).then(res => {
            if (!this.state.totaluser) this.setState({ totaluser: res.total.count })
            if (!this.state.totalpro) this.setState({ totalpro: res.profissional.count })
            if (!this.state.totalcli) this.setState({ totalcli: res.cliente.count })
        })

        this.days = [
            dayjs().subtract(7, 'day').hour(20).minute(59).toISOString(),
            dayjs().subtract(6, 'day').hour(20).minute(59).toISOString(),
            dayjs().subtract(5, 'day').hour(20).minute(59).toISOString(),
            dayjs().subtract(4, 'day').hour(20).minute(59).toISOString(),
            dayjs().subtract(3, 'day').hour(20).minute(59).toISOString(),
            dayjs().subtract(2, 'day').hour(20).minute(59).toISOString(),
            dayjs().subtract(1, 'day').hour(20).minute(59).toISOString(),
            dayjs().hour(20).minute(59).toISOString(),
        ]

        this.days.map(day => {
            client.request(`{
                    total: _allUsersMeta(filter: {
                      createdAt_lte: "${day}"
                    }) {
                      count
                    }
                    profissionais: _allUsersMeta(filter: {
                      createdAt_lte: "${day}"
                      player: {
                        type: PROFISSIONAL
                      }
                    }) {
                      count
                    }
                }`).then(res => {
                this.setState({
                    dayData: [
                        ...new Set([...this.state.dayData, [dayjs(day).format("DD/MM/YYYY"), parseInt(res.total.count), parseInt(res.profissionais.count)]])
                    ]
                })
            })
        })

        client.request(CountProposes).then(res => {
            if (!this.state.proposett) this.setState({ proposett: res.total.count })
            if (!this.state.proposeaberto) this.setState({ proposeaberto: res.aberto.count })
            if (!this.state.proposeaceito) this.setState({ proposeaceito: res.aceito.count })
            if (!this.state.proposecalcelado) this.setState({ proposecalcelado: res.cancelado.count })
            if (!this.state.proposefinalizado) this.setState({ proposefinalizado: res.finalizado.count })
            if (!this.state.proposeNO) this.setState({ proposeNO: res.naorealizado.count })
            if (!this.state.proposerecusado) this.setState({ proposerecusado: res.recusado.count })
        })


        client.request(CountUsersStates).then(res => {
            if (!this.state.AL) this.setState({ AL: res.ALtotal.count })
            if (!this.state.ALPro) this.setState({ ALPro: res.ALprofissional.count })
            if (!this.state.ALCli) this.setState({ ALCli: res.ALcliente.count })
            if (!this.state.AM) this.setState({ AM: res.AMtotal.count })
            if (!this.state.AMPro) this.setState({ AMPro: res.AMprofissional.count })
            if (!this.state.AMCli) this.setState({ AMCli: res.AMcliente.count })
            if (!this.state.AP) this.setState({ AP: res.APtotal.count })
            if (!this.state.APPro) this.setState({ APPro: res.APprofissional.count })
            if (!this.state.APCli) this.setState({ APCli: res.APcliente.count })
            if (!this.state.BA) this.setState({ BA: res.BAtotal.count })
            if (!this.state.BAPro) this.setState({ BAPro: res.BAprofissional.count })
            if (!this.state.BACli) this.setState({ BACli: res.BAcliente.count })
            if (!this.state.CE) this.setState({ CE: res.CEtotal.count })
            if (!this.state.CEPro) this.setState({ CEPro: res.CEprofissional.count })
            if (!this.state.CECli) this.setState({ CECli: res.CEcliente.count })
            if (!this.state.DF) this.setState({ DF: res.DFtotal.count })
            if (!this.state.DFPro) this.setState({ DFPro: res.DFprofissional.count })
            if (!this.state.DFCli) this.setState({ DFCli: res.DFcliente.count })
            if (!this.state.ES) this.setState({ ES: res.EStotal.count })
            if (!this.state.ESPro) this.setState({ ESPro: res.ESprofissional.count })
            if (!this.state.ESCli) this.setState({ ESCli: res.EScliente.count })
            if (!this.state.GO) this.setState({ GO: res.GOtotal.count })
            if (!this.state.GOPro) this.setState({ GOPro: res.GOprofissional.count })
            if (!this.state.GOCli) this.setState({ GOCli: res.GOcliente.count })
            if (!this.state.MA) this.setState({ MA: res.MAtotal.count })
            if (!this.state.MAPro) this.setState({ MAPro: res.MAprofissional.count })
            if (!this.state.MACli) this.setState({ MACli: res.MAcliente.count })
            if (!this.state.MT) this.setState({ MT: res.MTtotal.count })
            if (!this.state.MTPro) this.setState({ MTPro: res.MTprofissional.count })
            if (!this.state.MTCli) this.setState({ MTCli: res.MTcliente.count })
            if (!this.state.MS) this.setState({ MS: res.MStotal.count })
            if (!this.state.MSPro) this.setState({ MSPro: res.MSprofissional.count })
            if (!this.state.MSCli) this.setState({ MSCli: res.MScliente.count })
            if (!this.state.MG) this.setState({ MG: res.MGtotal.count })
            if (!this.state.MGPro) this.setState({ MGPro: res.MGprofissional.count })
            if (!this.state.MGCli) this.setState({ MGCli: res.MGcliente.count })
            if (!this.state.PA) this.setState({ PA: res.PAtotal.count })
            if (!this.state.PAPro) this.setState({ PAPro: res.PAprofissional.count })
            if (!this.state.PACli) this.setState({ PACli: res.PAcliente.count })
            if (!this.state.PB) this.setState({ PB: res.PBtotal.count })
            if (!this.state.PBPro) this.setState({ PBPro: res.PBprofissional.count })
            if (!this.state.PBCli) this.setState({ PBCli: res.PBcliente.count })
            if (!this.state.PR) this.setState({ PR: res.PRtotal.count })
            if (!this.state.PRPro) this.setState({ PRPro: res.PRprofissional.count })
            if (!this.state.PRCli) this.setState({ PRCli: res.PRcliente.count })
            if (!this.state.PE) this.setState({ PE: res.PEtotal.count })
            if (!this.state.PEPro) this.setState({ PEPro: res.PEprofissional.count })
            if (!this.state.PECli) this.setState({ PECli: res.PEcliente.count })
            if (!this.state.PI) this.setState({ PI: res.PItotal.count })
            if (!this.state.PIPro) this.setState({ PIPro: res.PIprofissional.count })
            if (!this.state.PICli) this.setState({ PICli: res.PIcliente.count })
            if (!this.state.RJ) this.setState({ RJ: res.RJtotal.count })
            if (!this.state.RJPro) this.setState({ RJPro: res.RJprofissional.count })
            if (!this.state.RJCli) this.setState({ RJCli: res.RJcliente.count })
            if (!this.state.RN) this.setState({ RN: res.RNtotal.count })
            if (!this.state.RNPro) this.setState({ RNPro: res.RNprofissional.count })
            if (!this.state.RNCli) this.setState({ RNCli: res.RNcliente.count })
            if (!this.state.RS) this.setState({ RS: res.RStotal.count })
            if (!this.state.RSPro) this.setState({ RSPro: res.RSprofissional.count })
            if (!this.state.RSCli) this.setState({ RSCli: res.RScliente.count })
            if (!this.state.RO) this.setState({ RO: res.ROtotal.count })
            if (!this.state.ROPro) this.setState({ ROPro: res.ROprofissional.count })
            if (!this.state.ROCli) this.setState({ ROCli: res.ROcliente.count })
            if (!this.state.RR) this.setState({ RR: res.RRtotal.count })
            if (!this.state.RRPro) this.setState({ RRPro: res.RRprofissional.count })
            if (!this.state.RRCli) this.setState({ RRCli: res.RRcliente.count })
            if (!this.state.SC) this.setState({ SC: res.SCtotal.count })
            if (!this.state.SCPro) this.setState({ SCPro: res.SCprofissional.count })
            if (!this.state.SCCli) this.setState({ SCCli: res.SCcliente.count })
            if (!this.state.SP) this.setState({ SP: res.SPtotal.count })
            if (!this.state.SPPro) this.setState({ SPPro: res.SPprofissional.count })
            if (!this.state.SPCli) this.setState({ SPCli: res.SPcliente.count })
            if (!this.state.SE) this.setState({ SE: res.SEtotal.count })
            if (!this.state.SEPro) this.setState({ SEPro: res.SEprofissional.count })
            if (!this.state.SECli) this.setState({ SECli: res.SEcliente.count })
            if (!this.state.TO) this.setState({ TO: res.TOtotal.count })
            if (!this.state.TOPro) this.setState({ TOPro: res.TOprofissional.count })
            if (!this.state.TOCli) this.setState({ TOCli: res.TOcliente.count })
            if (!this.state.AC) this.setState({ AC: res.ACtotal.count })
            if (!this.state.ACPro) this.setState({ ACPro: res.ACprofissional.count })
            if (!this.state.ACCli) this.setState({ ACCli: res.ACcliente.count })
            if (!this.state.AddressNull) this.setState({ AddressNull: res.NULLtotal.count })
            if (!this.state.AddressNullPro) this.setState({ AddressNullPro: res.NULLprofissional.count })
            if (!this.state.AddressNullCli) this.setState({ AddressNullCli: res.NULLcliente.count })

            this.setState({
                dataEstados: [
                    ['Estados', 'Usuarios total', 'Profissionais', 'Clientes'],
                    ['Acre (AC)', this.state.AC, this.state.ACPro, this.state.ACCli],
                    ['Alagoas (AL)', this.state.AL, this.state.ALPro, this.state.ALCli],
                    ['Amapá (AP)', this.state.AP, this.state.APPro, this.state.APCli],
                    ['Amazonas (AM)', this.state.AM, this.state.AMPro, this.state.AMCli],
                    ['Bahia (BA)', this.state.BA, this.state.BAPro, this.state.BACli],
                    ['Ceará (CE)', this.state.CE, this.state.CEPro, this.state.CECli],
                    ['Distrito Federal (DF)', this.state.DF, this.state.DFPro, this.state.DFCli],
                    ['Espírito Santo (ES)', this.state.ES, this.state.ESPro, this.state.ESCli],
                    ['Goiás (GO)', this.state.GO, this.state.GOPro, this.state.GOCli],
                    ['Maranhão (MA)', this.state.MA, this.state.MAPro, this.state.MACli],
                    ['Mato Grosso (MT)', this.state.MT, this.state.MTPro, this.state.MTCli],
                    ['Mato Grosso do Sul (MS)', this.state.MS, this.state.MSPro, this.state.MSCli],
                    ['Minas Gerais (MG)', this.state.MG, this.state.MGPro, this.state.MGCli],
                    ['Pará (PA)', this.state.PA, this.state.PAPro, this.state.PACli],
                    ['Paraíba (PB)', this.state.PB, this.state.PBPro, this.state.PBCli],
                    ['Paraná (PR)', this.state.PR, this.state.PRPro, this.state.PRCli],
                    ['Pernambuco (PE)', this.state.PE, this.state.PEPro, this.state.PECli],
                    ['Piauí (PI)', this.state.PI, this.state.PIPro, this.state.PICli],
                    ['Rio de Janeiro (RJ)', this.state.RJ, this.state.RJPro, this.state.RJCli],
                    ['Rio Grande do Norte (RN)', this.state.RN, this.state.RNPro, this.state.RNCli],
                    ['Rio Grande do Sul (RS)', this.state.RS, this.state.RSPro, this.state.RSCli],
                    ['Rondônia (RO)', this.state.RO, this.state.ROPro, this.state.ROCli],
                    ['Roraima (RR)', this.state.RR, this.state.RRPro, this.state.RRCli],
                    ['Santa Catarina (SC)', this.state.SC, this.state.SCPro, this.state.SCCli],
                    ['São Paulo (SP)', this.state.SP, this.state.SPPro, this.state.SPCli],
                    ['Sergipe (SE)', this.state.SE, this.state.SEPro, this.state.SECli],
                    ['Tocantins (TO)', this.state.TO, this.state.TOPro, this.state.TOCli],
                    ['Cadastro incompleto', this.state.AddressNull, this.state.AddressNullPro, this.state.AddressNullCli],
                ]
            })

        })

        this.createSkill = (e, CreateSkills) => {
            this.setState({ loading: true, showAlert: false })
            e.preventDefault()
            CreateSkills({
                variables: {
                    name: this.state.name,
                    category: this.state.category
                }
            }).then(
                res => {
                    console.log(res)
                    if (res.error) {
                        //mensagem de erro
                        this.setState({
                            showAlert: true,
                            show: false,
                            loading: false,
                            typeAlert: 'error',
                            titleAlert: 'Aconteceu algum erro',
                            messageAlert: `Informe esta menssagem ao desenvolvedor: ${res.erro.message}`,
                            onClose: () => window.location.reload()
                        })
                    } else if (res.data) {
                        //mensagem de sucesso res.data.createSkills
                        this.setState({
                            showAlert: true,
                            show: false,
                            loading: false,
                            typeAlert: 'success',
                            titleAlert: `Nova habilidade cadastrada com sucesso!`,
                            messageAlert: `${res.data.createSkills.name} está em ${res.data.createSkills.category.name}`,
                            onClose: () => window.location.reload()
                        })
                    }
                }
            )
        }

        this.createCategory = async (e, CreateCategory) => {
            this.setState({ loading: true })

            CreateCategory({
                variables: {
                    name: this.state.nameCat,
                    description: this.state.descriptionCat
                }
            }).then(async res => {

                if (res.error) {
                    //mensagem de erro
                    this.setState({
                        showAlert: true,
                        showCat: false,
                        loading: false,
                        typeAlert: 'error',
                        titleAlert: 'Aconteceu algum erro',
                        messageAlert: `Informe esta menssagem ao desenvolvedor: ${res.erro.message}`,
                        onClose: () => window.location.reload()
                    })
                }

                if (res.data.createCategory) {
                    //salvar imagem

                    if (this.state.file) {

                        const files = this.state.file

                        // console.log(files)

                        const file = files[0]

                        this.setState({ fileName: file.name })


                        const cache = JSON.parse(sessionStorage.getItem('OITO'))

                        let data = new FormData();
                        data.append('data', file)

                        await axios.post('https://api.graph.cool/file/v1/oitoapi', data, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Authorization': `Bearer ${cache.token}`
                            },
                            onUploadProgress: ProgressEvent => {
                                this.setState({
                                    now: parseInt(ProgressEvent.loaded / ProgressEvent.total * 100),
                                })
                                // console.log("arquivo ", ProgressEvent.loaded / ProgressEvent.total * 100)
                            }
                        }).then(resp => {
                            // console.log(resp.data.id)

                            const client = new GraphQLClient(endpoint, {
                                headers: {
                                    Authorization: `Bearer ${cache.token}`,
                                }
                            })

                            client.request(`
                                    mutation{
                                        updateFile (
                                       id: "${resp.data.id}",
                                       categoryId: "${res.data.createCategory.id}"
                                   ){
                                   id
                                     name
                                 }
                                 }
                                    `).then(
                                resp2 => {
                                    console.log(resp2)
                                    this.setState({
                                        showAlert: true,
                                        showCat: false,
                                        loading: false,
                                        typeAlert: 'success',
                                        titleAlert: `Nova categoria cadastrada com sucesso!`,
                                        messageAlert: `${res.data.createCategory.name} foi criada.`,
                                        onClose: () => window.location.reload()
                                    })
                                }
                            ).catch(err => {
                                console.log(err)
                                this.setState({
                                    showAlert: true,
                                    showCat: false,
                                    loading: false,
                                    typeAlert: 'error',
                                    titleAlert: 'Aconteceu algum erro',
                                    messageAlert: `Informe esta menssagem ao desenvolvedor: ${err.message}`,
                                    onClose: () => window.location.reload()
                                })
                                // this.refetch()
                                // this.setState({ loading: false, fileName: 'Escolha um arquivo' })
                            })
                        })

                        this.setState({ loadingprogress: false, fileName: 'Escolha um arquivo' })

                    } else {
                        this.setState({ loadingprogress: false, fileName: 'Escolha um arquivo' })
                    }

                    //update da categoria
                    // client.request(``)
                }

            })
        }*/

    }

    render() {

        return (
            <div className="col-xs-12" id="paineladm">
                <Navbar />

                <div className="row">

                    <Simplert
                        showSimplert={this.state.showAlert}
                        type={this.state.typeAlert}
                        title={this.state.titleAlert}
                        message={this.state.messageAlert}
                        customCloseBtnText={this.state.customCloseBtnText}
                        customCloseBtnClass={this.state.customCloseBtnClass}
                        onClose={this.state.onClose}
                    />

                    {/* menu */}
                    <div className="col-xs-12" id="menu">
                        <div style={!this.state.show ? { textDecoration: "underline" } : null}>Dashboard</div>
                        {this.editCat ? <><div onClick={() => this.setState({ show: !this.state.show })}>Cadastro de habilidades</div>
                            <div onClick={() => this.setState({ showCat: !this.state.showCat })}>Cadastro de categoria</div></>
                            : null}

                    </div>


                    {/* graficos */}
                    <div className="col-xs-12" id="graficos">

                        {window.innerWidth > 800 ? <>
                            {this.state.dayData.length > 8 ?
                                <Chart
                                    width={'80vw'}
                                    height={'80vh'}
                                    // chartType="LineChart"
                                    chartType="Bar"
                                    loader={<div>Carregando grafico</div>}
                                    data={this.state.dayData}
                                    options={{
                                        chart: {
                                            title: `Total de Usuários ${this.state.totaluser}. ${parseFloat((this.state.totalpro * 100 / this.state.totaluser).toFixed(2))}% profissionais e ${parseFloat((this.state.totalcli * 100 / this.state.totaluser).toFixed(2))}% de clientes`,
                                        },
                                    }}
                                    // For tests
                                    rootProps={{ 'data-testid': '6' }}
                                /> : <div>Carregando grafico</div>}

                            {/* {this.state.totaluser !== undefined ? <Chart
                            width={'25vw'}
                            height={'200px'}
                            chartType="PieChart"
                            loader={<div>Carregando grafico</div>}
                            data={[
                                ['Usuarios', 'Quantidade'],
                                ['Profissional', this.state.totalpro],
                                ['Cliente', this.state.totalcli],
                            ]}
                            options={{
                                title: `Total de usuarios ${this.state.totaluser}`,
                            }}
                            rootProps={{ 'data-testid': '1' }}
                        /> : null} */}

                            <Chart
                                width={'80vw'}
                                height={'400px'}
                                chartType="Bar"
                                loader={<div>Carregando grafico</div>}
                                data={[
                                    ['Status', 'Propostas'],
                                    ['Em aberto', this.state.proposeaberto],
                                    ['Aceitas', this.state.proposeaceito],
                                    ['Canceladas', this.state.proposecalcelado],
                                    ['Finalizadas', this.state.proposefinalizado],
                                    ['Não respondidas', this.state.proposeNO],
                                    ['Recusadas', this.state.proposerecusado],
                                ]}
                                options={{
                                    chart: {
                                        title: `Total de propostas ${this.state.proposett}`,
                                    },
                                    chartArea: { width: '50%' },
                                }}
                                rootProps={{ 'data-testid': '2' }}
                            />

                            {this.state.dataEstados.length > 1 ? <Chart
                                width={'80vw'}
                                height={'1500px'}
                                chartType="Bar"
                                loader={<div>Carregando grafico</div>}
                                data={this.state.dataEstados}
                                options={{
                                    chart: {
                                        title: 'Usuarios por estado',
                                        subtitle: 'Valido somente para quem finalizou o cadastro',
                                    },
                                    chartArea: { width: '50%' },
                                    bars: 'horizontal',
                                    axes: {
                                        y: {
                                            0: { side: 'right' },
                                        },
                                    },
                                }}
                                rootProps={{ 'data-testid': '3' }}
                            /> : null}

                            <Query query={AnunciosAll}>
                                {res => {
                                    // console.log(res ? res.data ? res.data.allSkillses ? res.data.allSkillses : null : null : null)
                                    // return res? <p>{res}</p> : null
                                    let skillList = [['Habilidade', 'Anuncios', 'Propostas']]
                                    if (res && res.data && res.data.allSkillses) {
                                        res.data.allSkillses.map(skill =>
                                            skillList.push([
                                                skill.name,
                                                skill._anunciosesMeta.count,
                                                skill.anuncioses.reduce((prev, elem) => prev + elem._proposesMeta.count, 0)
                                            ]))
                                    }

                                    return skillList.length > 1 ?
                                        <Chart
                                            width={'80vw'}
                                            height={'2600px'}
                                            chartType="Bar"
                                            loader={<div>Carregando grafico</div>}
                                            data={skillList}
                                            options={{
                                                chart: {
                                                    title: `Anuncios por habilidade Total: ${skillList.reduce((prev, elem) => prev + (typeof elem[1] !== 'string' ? elem[1] : null), 0)}`,
                                                },
                                                bars: 'horizontal',
                                                axes: {
                                                    y: {
                                                        0: { side: 'right' },
                                                    },
                                                },
                                            }}
                                            rootProps={{ 'data-testid': '3' }}
                                        />
                                        : null
                                }}
                            </Query>
                        </>
                            : <>
                                {/* //tabelas em telas pequenas */}
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="3">Usuários</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Total</th>
                                            <td colSpan="2">{this.state.totaluser}</td>
                                        </tr>
                                        <tr>
                                            <th>Profissionais</th>
                                            <td colSpan="2">{this.state.totalpro} - {parseFloat((this.state.totalpro * 100 / this.state.totaluser).toFixed(2))}%</td>
                                        </tr>
                                        <tr>
                                            <th>Clientes</th>
                                            <td colSpan="2">{this.state.totalcli} - {parseFloat((this.state.totalcli * 100 / this.state.totaluser).toFixed(2))}%</td>
                                        </tr>
                                        {this.state.dayData.map((day, i) =>
                                            <tr key={i}>
                                                <th>{day[0]}</th>
                                                <td>{day[1]}</td>
                                                <td>{day[2]}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="2">Propostas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Total</th>
                                            <td>{this.state.proposett}</td>
                                        </tr>
                                        <tr>
                                            <th>Em aberto</th>
                                            <td>{this.state.proposeaberto}</td>
                                        </tr>
                                        <tr>
                                            <th>Aceitas</th>
                                            <td>{this.state.proposeaceito}</td>
                                        </tr>
                                        <tr>
                                            <th>Canceladas</th>
                                            <td>{this.state.proposecalcelado}</td>
                                        </tr>
                                        <tr>
                                            <th>Finalizadas</th>
                                            <td>{this.state.proposefinalizado}</td>
                                        </tr>
                                        <tr>
                                            <th>Não respondidas</th>
                                            <td>{this.state.proposeNO}</td>
                                        </tr>
                                        <tr>
                                            <th>Recusadas</th>
                                            <td>{this.state.proposerecusado}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="4">Usuários por estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dataEstados.length > 0 ?
                                            this.state.dataEstados.map((state, i) =>
                                                <tr key={i}>
                                                    <th>{state[0]}</th>
                                                    <td>{state[1]}</td>
                                                    <td>{state[2]}</td>
                                                    <td>{state[3]}</td>
                                                </tr>
                                            ) : null}
                                    </tbody>

                                </table>
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="3">Anúncios</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <Query query={AnunciosAll}>
                                            {res => {
                                                // console.log(res ? res.data ? res.data.allSkillses ? res.data.allSkillses : null : null : null)
                                                // return res? <p>{res}</p> : null
                                                let skillList = [['Habilidade', 'Anuncios', 'Propostas']]
                                                if (res && res.data && res.data.allSkillses) {
                                                    res.data.allSkillses.map(skill =>
                                                        skillList.push([
                                                            skill.name,
                                                            skill._anunciosesMeta.count,
                                                            skill.anuncioses.reduce((prev, elem) => prev + elem._proposesMeta.count, 0)
                                                        ]))
                                                }

                                                return skillList.length > 1 ? <>
                                                    <tr>
                                                        <th>Total</th>
                                                        <td colSpan="2">{skillList.reduce((prev, elem) => prev + (typeof elem[1] !== 'string' ? elem[1] : null), 0)}</td>
                                                    </tr>
                                                    {skillList.map((skill, i) =>
                                                        <tr key={i}>
                                                            <th>{skill[0]}</th>
                                                            <td>{skill[1]}</td>
                                                            <td>{skill[2]}</td>
                                                        </tr>
                                                    )}
                                                </>
                                                    : null
                                            }}
                                        </Query>
                                    </tbody>
                                </table>
                            </>}
                    </div>
                </div>


                <Modal show={this.state.show} title={`Cadastro de habilidade`} onClose={() => this.setState({ show: !this.state.show })} >
                    {/* {console.log(this.state.anuncio.id)} */}
                    {this.state.loading ? <Loading /> :
                        <form className="row start-xs">

                            <div className="col-xs-12">
                                <Input name="name" label="Nome da habilidade" placeholder="Digite o nome da habilidade" type="text" onInput={(e) => this.setState({ name: e.target.value })} />
                            </div>

                            <div className="col-xs-12 center-xs catg">
                                <Query query={Categories}>
                                    {result => {
                                        if (result.loading) return <Loading />
                                        if (result.error) return <p>{result.error.message}</p>
                                        // console.log(result.data.allCategories)
                                        return <ErrorBoundary>
                                            {result.data.allCategories.length ?
                                                result.data.allCategories.map((p, i) =>
                                                    // style={this.state.category === p.id ? {color: 'red'} : null}
                                                    <IconCtg key={i} icon={p.file} label={true} name={p.name} small={true} active={this.state.category === p.id ? true : false} onClick={() => this.setState({ category: p.id })} />
                                                ) : null}
                                        </ErrorBoundary>
                                    }}
                                </Query>
                            </div>

                            <div className="col-xs-12 end-xs" style={{ marginBottom: "30px" }}>
                                <div onClick={() => this.setState({ open: !this.state.open })}>Sugestões de habilidades <FontAwesomeIcon icon={this.state.open ? faChevronUp : faChevronDown} size={'1x'} /></div>
                                <div style={this.state.open ? { display: 'block' } : { display: "none" }}>
                                    <Query query={newHabs}>
                                        {res => {
                                            return res.data.allHabilidades ?
                                                res.data.allHabilidades.map((hab, i) =>
                                                    <div key={i} style={{ borderBottom: "1px solid lightgrey" }}>{hab.name}</div>
                                                ) : null
                                        }}
                                    </Query>
                                </div>
                            </div>

                            <Mutation mutation={CreateSkills}>
                                {(CreateSkills, { loading, error }) => {
                                    if (loading) return <Loading />
                                    if (error) return <p>Algo de errado aconteceu. Tente novamente.</p>
                                    return <Button name='Salvar' type='submit' onClick={(e) => this.createSkill(e, CreateSkills)} />
                                }}
                            </Mutation>
                        </form>}
                </Modal>

                <Modal show={this.state.showCat} title={`Cadastro de categoria`} onClose={() => this.setState({ showCat: !this.state.showCat })} >
                    {/* {console.log(this.state.anuncio.id)} */}
                    {this.state.loading ? <Loading /> :
                        <form className="row start-xs">

                            <div className="col-xs-12">
                                <Input name="name" label="Nome da categoria" placeholder="Digite o nome da categoria" type="text" onInput={(e) => this.setState({ nameCat: e.target.value })} />
                            </div>

                            <div className="col-xs-12">
                                <Input name="description" label="Descrição da categoria" placeholder="Digite uma descrição para a categoria" type="text" onInput={(e) => this.setState({ descriptionCat: e.target.value })} />
                            </div>


                            <div className="col-xs-12 end-xs" style={{ marginBottom: "30px" }}>
                                <p><small>Para que todas as imagens fiquem propocionais favor seguir estes requisitos: - Imagem em SVG. - Documento transparente com tamanho de 989px de largura por 1149px de altura contendo o - Vetor na cor roxa #4d2565ff no tamanho de 908x908px centralizado no documento.</small></p>
                                <FileInput name={'fileInputs'} onchange={(e) => this.setState({ file: e.target.files })} accept="image/*" id="uploadPortfolio" filename={this.state.fileName} />
                            </div>

                            <Mutation mutation={CreateCategory}>
                                {(CreateCategory, { loading, error }) => {
                                    if (loading) return <Loading />
                                    if (error) return <p>Algo de errado aconteceu. Tente novamente.</p>
                                    return <Button name='Salvar' type='submit' onClick={(e) => this.createCategory(e, CreateCategory)} />
                                }}
                            </Mutation>
                        </form>}
                </Modal>

            </div>
        )
    }
}